import React from 'react'
import { Chart } from 'react-google-charts';

const DeliveredResourcePieChart = ({data}) => {

    const chartData = [['Resource', 'Count'], ...data];

  return (
    <div>
    {
        // data.length > 1 ?
            <div style={{
                height: "55vh",
                // border: "3px solid",
            }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <Chart
                        width={'100%'}
                        height="100%"
                        chartType="PieChart"
                        loader={
                            <div className='d-flex align-items-center justify-content-center flex-column'
                style={{
                    // border: "2px solid black",
                    // borderRadius: "15px",
                    height: '50vh'
                }}>
                Loading...
            </div>
                        }
                        data={chartData}
                      options={{
                        backgroundColor:"#ddd",
                        title: 'Resource Delivered',
                        
                      }}
                    />
                </div>
            </div>

            // :
            // <div className='d-flex align-items-center justify-content-center flex-column'
            //     style={{
            //         border: "2px solid black",
            //         // borderRadius: "15px",
            //         height: '50vh'
            //     }}>
            //     Loading...
            // </div>
    }
</div>
  )
}

export default DeliveredResourcePieChart
